
// Redux
import { useSignalRReducer } from '@/main/store/signalR';

// Utils & Models
import { SignalRDynamicReportResponse, SignalRExportInventoryResponse, SignalRImportPDFQuoteResponse, SignalRPrequoteResponse, SignalRRateImportResponse, SignalRReceiveUpdatesRequoteClaimResponse, SignalRReceiveUpdatesRequoteMultiClaimResponse, SignalRReceiveUpdatesRequotePartResponse, SignalRStripePaymentFlowResponse } from '@/main/models/common/signalRReceiveUpdatesResponse';
import { SendUpdatesSignalRTypeEnum } from '@/main/services/enum/SendUpdatesSignalRTypeEnum';
import { isNullUndefined } from '@/main/services/utils';

// Components
import HubItemDynamicReport from '@/main/components/shared/hub/HubItemDynamicReport';
import HubItemRateImport from '@/main/components/shared/hub/HubItemRateImport';
import HubItemRequoteMultiClaim from '@/main/components/shared/hub/HubItemRequoteMultiClaim';
import HubItemExportInventory from './HubItemExportInventory';
import HubItemImportPDFQuote from './HubItemImportPDFQuote';
import HubItemPrequote from './HubItemPrequote';
import HubItemRequoteClaim from './HubItemRequoteClaim';
import HubItemRequoteNationalPart from './HubItemRequoteNationalPart';
import HubItemRequotePart from './HubItemRequotePart';
import HubItemStripePaymentFlow from './HubItemStripePaymentFlow';

interface IHubContainerProps {
  type: SendUpdatesSignalRTypeEnum;
  customProps?: any;
}
const HubContainer = ({
  type,
  customProps
}: IHubContainerProps) => {
  const { content, sendUpdatesSignalRTypeCurrent } = useSignalRReducer();

  function getDataArray<T>(dataType: SendUpdatesSignalRTypeEnum) {
    const currentDataByKey = content[dataType] as T[];
    return currentDataByKey;
  }

  function renderData() {
    const dataRequotePart = getDataArray<SignalRReceiveUpdatesRequotePartResponse>(sendUpdatesSignalRTypeCurrent);
    const dataRequoteNationalPart = getDataArray<SignalRReceiveUpdatesRequotePartResponse>(sendUpdatesSignalRTypeCurrent);
    const dataStripePaymentFlow = getDataArray<SignalRStripePaymentFlowResponse>(sendUpdatesSignalRTypeCurrent);
    const dataExportInventory = getDataArray<SignalRExportInventoryResponse>(sendUpdatesSignalRTypeCurrent);
    const dataImportPDFQuote = getDataArray<SignalRImportPDFQuoteResponse>(sendUpdatesSignalRTypeCurrent);
    const dataPrequote = getDataArray<SignalRPrequoteResponse>(sendUpdatesSignalRTypeCurrent);
    const dataRequoteClaim = getDataArray<SignalRReceiveUpdatesRequoteClaimResponse>(sendUpdatesSignalRTypeCurrent);
    const dataDynamicReport = getDataArray<SignalRDynamicReportResponse>(sendUpdatesSignalRTypeCurrent);
    const dataRequoteMultiClaim = getDataArray<SignalRReceiveUpdatesRequoteMultiClaimResponse>(sendUpdatesSignalRTypeCurrent);
    const dataRateImport = getDataArray<SignalRRateImportResponse>(sendUpdatesSignalRTypeCurrent);

    const typeConfig = {
      [SendUpdatesSignalRTypeEnum.RequoteProcurement]: { component: HubItemRequotePart, data: dataRequotePart },
      [SendUpdatesSignalRTypeEnum.StripePaymentFlow]: { component: HubItemStripePaymentFlow, data: dataStripePaymentFlow },
      [SendUpdatesSignalRTypeEnum.RequoteNational]: { component: HubItemRequoteNationalPart, data: dataRequoteNationalPart },
      [SendUpdatesSignalRTypeEnum.ExportInventory]: { component: HubItemExportInventory, data: dataExportInventory },
      [SendUpdatesSignalRTypeEnum.ImportPDFQuote]: { component: HubItemImportPDFQuote, data: dataImportPDFQuote },
      [SendUpdatesSignalRTypeEnum.PreQuote]: { component: HubItemPrequote, data: dataPrequote },
      [SendUpdatesSignalRTypeEnum.RequoteClaim]: { component: HubItemRequoteClaim, data: dataRequoteClaim },
      [SendUpdatesSignalRTypeEnum.DynamicReport]: { component: HubItemDynamicReport, data: dataDynamicReport },
      [SendUpdatesSignalRTypeEnum.RequoteItemsMultiClaim]: { component: HubItemRequoteMultiClaim, data: dataRequoteMultiClaim },
      [SendUpdatesSignalRTypeEnum.RateImport]: { component: HubItemRateImport, data: dataRateImport },
    };
    const config = typeConfig[type];

    if (config && !isNullUndefined(config.data) && config.data[0]?.sendUpdatesSignalRType === type) {
      const { component: Component, data } = config;
      return <Component data={data as any} customProps={customProps} />;
    }
    return <></>;
  }

  return renderData();
};

export default HubContainer;
